import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Trending() {
  const [blog, setBlog] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://tamizhtechie-test.herokuapp.com/blog/")
      .then((res) => {
        setBlog(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const name = "trending";

  return (
    <div className="herosection">
      <div className="home-top-news">
        <div className="home-top-img">
          <div className="row">
            {blog
              .filter((blog) => blog.category === name)
              .slice(-1)
              .map((herosection) => {
                return (
                  <>
                    <Link
                      to={{
                        pathname: "/blog" + "/" + herosection.slug,
                      }}
                    >
                      <div>
                        <img
                          src={herosection.imageUrl}
                          alt={herosection.imgalt}
                          className="img-fluid"
                        />
                        <div class="home-top-title">
                          <h4>{herosection.category}</h4>
                          <br />
                          <h5>{herosection.title}</h5>
                          <h6>
                            <span className="icon-timeline"></span>
                            <i
                              className="fa fa-calendar pr-3"
                              aria-hidden="true"
                            ></i>{" "}
                            {herosection.date}
                          </h6>
                        </div>
                      </div>
                    </Link>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
